import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
//import { PurchaseEvents } from './PurchaseEvents';
import { ComboService, DesignService } from "../../../services/index";

@Component({
  selector: "modal-content",
  templateUrl: "./addEditdesignList.html",
})
export class AddEditDesignList {
  @Output() partyUpdateEvent = new EventEmitter();
  row: any;
  data: any = [];
  qualityList: any;
  colorList: any;
  codeList: any;
  designList = [];
  typeList = [];
  brandList: any;
  styleList: any;
  fitList: any;
  mode: string;
  saveEvent: any;
  agentList: any;
  partyCodeList: any;
  isLoading: boolean = false;
  designdata: any = { code: "", color: "", fabcolor: "" };
  @Input() set design(val: any) {
    this.designdata = val;
    if (val.mode == "Edit") {
      this.designdata.mtr = "";
      this.designdata.code = "";
      this.designdata.color = "";
      this.designdata.fab_color = "";
      this.loadlist(val.des_id);
    }
  }
  @ViewChild("typeAuto") typeAuto;
  @ViewChild("statusAuto") statusAuto;
  @ViewChild("shiftauto") shiftauto;
  @ViewChild("partyForm") partyForm;
  shiftCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    public bsModalRef: BsModalRef,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private comboService: ComboService,
    private designService: DesignService
  ) {
    // this.mode = this.stockdata.mode;
  }
  ngOnInit() {
    this.getBrandList();
    this.getStyleList();
    this.getTypeList();
    this.getQualityList();
    this.getFitList();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      $("#design_num").focus();
    }, 100);
  }

  onEnterKeyPressed(nextEl: string) {
    event.preventDefault();
    if ($(".swal2-container").length > 0) {
      return false;
    }
    if (nextEl == "partySave" && this.partyForm.valid) {
      //this.onSaveBrand();
    } else if (nextEl == "code") {
      $("#code").focus();
    } else if (nextEl == "add") {
      //  $('#pack' + nextEl).focus();

      this.pushrow();
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  pushrow() {
    let row = {
      mtr: this.designdata.mtr,
      code: this.designdata.code,
      color: this.designdata.color,
      fab_color: this.designdata.fab_color,
    };
    if (
      this.designdata.mtr > 0 &&
      this.designdata.code != "" &&
      this.designdata.color != "" &&
      this.designdata.fab_color != ""
    ) {
      this.designList.push(row);

      this.designdata.mtr = "";
      this.designdata.code = "";
      this.designdata.color = "";
      this.designdata.fab_color = "";
      $("#mtr").focus();
    }
  }

  deleterow(ind) {
    this.designList.splice(ind, 1);
  }

  getBrandList() {
    this.comboService.getBrandList().then((res: any) => {
      this.brandList = res;
    });
  }

  getStyleList() {
    this.comboService.getstyleList().then((res: any) => {
      this.styleList = res;
    });
  }

  getTypeList() {
    this.comboService.gettypeList().then((res: any) => {
      this.typeList = res;
    });
  }

  getQualityList() {
    this.comboService.getqualityList().then((res: any) => {
      this.qualityList = res;
    });
  }

  getFitList() {
    this.comboService.getfitList().then((res: any) => {
      this.fitList = res;
    });
  }
  loadlist(id) {
    let params = {
      des_id: id,
    };
    this.designService.loadlist(params).then((res: any) => {
      this.designList = res.data;
    });
  }

  onSaveDesign(): void {
    if (
      this.designdata.design_no == "" ||
      this.designdata.brand == "" ||
      this.designdata.style == "" ||
      this.designdata.type == "" ||
      this.designdata.fit == "" ||
      this.designdata.quality == "" ||
      this.designdata.mrp == "" ||
      this.designdata.fsrate == "" ||
      this.designdata.hsrate == ""
    ) {
      swal("Make sure that all the entries are given!");
    } else {
      let that = this;
      let params = Object.assign({}, this.designdata);
      params["design_type"] = "Core";
      params["category"] =
        this.designdata.brand.substring(0, 2) + this.designdata.mrp;
      params["design_det"] = JSON.stringify(this.designList);
      this.isLoading = true;
      this.designService
        .addDesignList(params)
        .then(function (res: any) {
          that.isLoading = false;
          if (res.success) {
            that.designdata = {
              userid: "",
              username: "",
              password: "",
              fullname: "",
              address: "",
              phone: "",
              email: "",
              usertype: "",
              doj: "",
              status: "",
              designation: "",
            };

            that.bsModalRef.hide();
            that.partyUpdateEvent.emit();
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });
          } else {
            swal("ERROR", res.message, "error");
          }
        })
        .catch(function (error: any) {
          that.isLoading = false;
          let res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
          //console.log(error);
        });
    }
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/master/DesignList/addEditdesignList.ts